<template>
  <div>
    <a-modal
      :visible="visible"
      :title="modalTit"
      on-ok="handleOk"
      :mask-closable="false"
      :ok-text="okTTxt"
      :cancel-text="cancelTxt"
      width="585px"
      :destroy-on-close="true"
      :confirm-loading="confirmLoading"
      @ok="onSave"
      @cancel="onClose"
    >
      <a-form
        :form="form"
        hide-required-mark
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${groupTit}：`"
        >
          <a-input
            v-decorator="['groupname', { rules: [{ required: true, message: groupNamePlace }],initialValue: editGroupValue}]"
            style="width:320px;"
            maxlength="15"
            @change="handleGroupName"
          >
            <span
              slot="addonAfter"
              style="color:#C0C4CC;border:none"
            >{{ editGroupValue.length }}/15</span>
          </a-input>
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${leaderTit}：`"
        >
          <a-select
            class="search-select"
            mode="multiple"
            :placeholder="selectPlaceholder"
            :value="defaultValues"
            @change="handleChangegroup"
          >
            <a-icon
              slot="suffixIcon"
              type="search"
            />
            <a-select-option
              v-for="(items,groupIndex) in remainMembers"
              :key="groupIndex"
              :value="items.truename+'-'+items.userid"
            >
              {{ items.truename }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <div v-if="isDisplayRemain===1">
          <!-- <a-form-item
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <span slot="label">
              <a-popover
                placement="bottomLeft"
                overlay-class-name="in-tip-class"
              >
                <template slot="content">
                  <p style="color:#999;">询盘信息分配给跟进人员的方式，会影响到信息分配规则的设置</p>
                </template>
                <i class="iconfont iconicon-test34" />
              </a-popover>
              信息分配方式
            </span>
            <a-radio-group
              name="radioGroup"
              :value="radioGroupDefault"
              @change="handleRadioChange"
            >
              <span
                v-for="item in groupSetRemainData"
                :key="item.value"
              >
                <span v-if="groupMemberLeaderList.length>0">
                  <a-radio :value="item.value">{{ item.name }}</a-radio>
                </span>
                <span v-else>
                  <a-radio
                    v-if="item.value!=='4'"
                    :value="item.value"
                  >{{ item.name }}</a-radio>
                </span>
              </span>
            </a-radio-group>
            <a-button
              v-if="radioGroupDefault==='3'"
              class="editlimit-btn"
              @click="editlimit"
            >
              编辑额度
            </a-button>
          </a-form-item> -->
        </div>
        <a-form-item
          v-if="groupPermissionList.length"
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${leaderLimitTit}：`"
        >
          <div
            v-for="(item,index) in permissionDatas"
            :key="index+item.label"
          >
            <div>
              <a-checkbox
                :indeterminate="item.indeterminate"
                :checked="item.selected"
                @change="onCheckAllChange($event,item,index)"
              >
                {{ item.label }}
              </a-checkbox>
            </div>
            <a-checkbox-group
              v-model="item.defaultSelect"
              class="margin-left-16"
              :options="item.child"
              @change="onChange($event,item,index)"
            />
          </div>
        </a-form-item>
      </a-form>
      <!-- <div class="group-seting-footer">
        <a-button
          type="primary"
          class="save-btn"
          :loading="groupFinalLoading"
          @click="onSave"
        >
          保存
        </a-button>
        <a-button @click="onClose">
          取消
        </a-button>
      </div> -->
    </a-modal>
    <!-- <EditLimit /> -->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import EditLeaderGroup from './EditGroupLeaderDialog'
// import EditLimit from './EditLimitDialog'
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 }
}
export default {
  components: {
    // EditLimit
  },
  data () {
    return {
      remainMembers: [],
      defaultValues: [],
      radioGroupDefault: '1',
      formItemLayout,
      form: this.$form.createForm(this),
      visible: false,
      plainOptions: [],
      selectedValues: [],
      permissionDatas: [],
      currentGroupId: '',
      currentRoleId: '',
      editLeader: 0,
      confirmLoading: false,
      editGroupValue: '',
      clonegroupName: ''
    }
  },
  computed: {
    ...mapState('team/group', ['groupFinalLoading', 'divideObj', 'editGroupSet', 'groupSetVisible', 'isDisplayRemain', 'groupSetRemainData', 'groupMemberLeaderList', 'groupPermissionList', 'groupMemberList']),
    ...mapState('team/manage', ['selectTreenDataKey', 'teamItemName']),
    groupNamePlace () {
      return this.$t('message["815"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    groupTit () {
      return this.$t('message["1335"]')
    },
    modalTit () {
      return this.$t('message["1337"]')
    },
    leaderLimitTit () {
      return this.$t('message["1673"]')
    },
    leaderTit () {
      return this.$t('message["1672"]')
    }
  },
  watch: {
    groupSetVisible (val) {
      this.visible = val
    },
    selectTreenDataKey (val) {
      if (!val) return
      if (val.indexOf('|') >= 0) {
        const [roleArr, groupArr] = val.split('|')
        const roleArrInfo = roleArr.split('-')
        const groupArrInfo = groupArr.split('-')
        this.currentGroupId = groupArrInfo[1]
        this.currentRoleId = roleArrInfo[1]
        const json = this.editGroupSet
        json.groupid = groupArrInfo[1]
        this.changeEditGroupSet(json)
      }
    },
    groupPermissionList (val) {
      if (!val) return
      this.permissionDatas = this.formatePermissionDatas(val)
    },
    groupMemberLeaderList (val) {
      if (!val) return
      let temp = []
      if (Array.isArray(val)) {
        val.map(value => {
          temp.push(value.userid)
        })
      }
      this.editGroupSet.leader = temp
      this.remainMembers = this.groupMemberList
      this.defaultValues = this.getDefaultDatas(val)
    },
    divideObj (val) {
      if (!val) return
      this.radioGroupDefault = val.divide_type.toString()
    },
    teamItemName (val) {
      if (!val) return
      this.editGroupValue = val
      this.clonegroupName = val
    }
  },
  inject: ['reload'],
  methods: {
    ...mapMutations('team/group', ['setLeaderDataStatus', 'setGroupMemberLeaderList']),
    ...mapActions('team/group', ['changeGroupLeaderEditSaveLoading', 'changeGroupFinalLoading', 'fetchSaveGroupLeader', 'changeEditGroupSet', 'changeGroupEditLimitVisible', 'changeGroupSetVisible', 'changeGroupLeaderEditVisible', 'fetchGetGroupSetPermissionDatas', 'fetchSubmitGroupSetPermissionDatas']),
    ...mapActions('team/manage', ['fetchGroupMemberDatas']),
    showDrawer () {
      this.visible = true
    },
    editlimit () {
      this.changeGroupLeaderEditSaveLoading(false)
      this.changeGroupEditLimitVisible(true)
    },
    // handleRadioChange (val) {
    //   let json = this.editGroupSet
    //   json.divide_type = val.target.value
    //   this.radioGroupDefault = val.target.value
    //   this.changeEditGroupSet(json)
    // },
    onClose () {
      this.changeGroupFinalLoading(false)
      this.changeGroupSetVisible(false)
      this.editGroupValue = this.clonegroupName
      // this.form.setFieldsValue({
      //   'groupname': this.clonegroupName
      // })
    },
    onSave () {
      // this.editGroupSet.leader = this.defaultValues
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          this.editGroupSet.groupname = this.editGroupValue
          this.changeGroupFinalLoading(true)
          const chain = await this.fetchSaveGroupLeader(this.editGroupSet)
          chain.onSuccess(raw => {
          })
          setTimeout(() => {
            this.fetchGroupMemberDatas(this.editGroupSet.groupid)
          })
        }
      })
      // this.reload()
      // this.fetchSubmitGroupSetPermissionDatas({ roleid: this.currentRoleId, permission: this.getSelectedId() })
    },
    getSelectedId () {
      let selectedId = []
      if (Array.isArray(this.permissionDatas)) {
        this.permissionDatas.map(value => {
          if (value.selected) {
            selectedId.push(value.value)
          }
          selectedId = selectedId.concat(value.defaultSelect)
        })
      }
      return selectedId
    },

    formatePermissionDatas (value) {
      let tempArray = []
      if (Array.isArray(value)) {
        value.map(values => {
          const json = {
            label: values.name,
            value: values.id,
            indeterminate: false,
            disabled: !values.cancel,
            selected: values.selected,
            defaultSelect: [],
            child: []
          }
          if (values.child) {
            values.child.map((item, index) => {
              if (item.selected) {
                json.defaultSelect.push(item.id)
              }
              json.child.push({
                label: item.name,
                value: item.id,
                selected: item.selected,
                disabled: !item.cancel
              })
            })
          }
          tempArray.push(json)
        })
      }
      return tempArray
    },
    onChange (checkedList, item, index) {
      item.indeterminate = !!checkedList.length && (checkedList.length < item.child.length)
      item.selected = checkedList.length === item.child.length
      this.$set(this.permissionDatas, index, item)
    },
    onCheckAllChange (e, item, index) {
      if (Array.isArray(item.child)) {
        item.child.map((value, indexchild) => {
          value.selected = e.target.checked
          item.defaultSelect.push(value.value)
        })
      }
      if (!e.target.checked) {
        item.defaultSelect = []
      }
      item.indeterminate = false
      item.selected = e.target.checked
      this.$set(this.permissionDatas, index, item)
    },
    formateSelectedDatas (array) {
      let tempValue = []
      if (Array.isArray(array)) {
        array.map(value => {
          if (value.selected) {
            tempValue.push(value.id)
          }
          if (value.child) {
            if (Array.isArray(value.child)) {
              value.child.map(values => {
                if (values.selected) {
                  tempValue.push(values.id)
                }
              })
            }
          }
        })
      }
      return tempValue
    },
    handleChangegroup (val) {
      this.defaultValues = val
      let subData = []
      let json = this.editGroupSet
      this.subUsers = []
      if (Array.isArray(val)) {
        val.map(value => {
          const tep = value.split('-')
          subData.push(tep[1])
          this.subUsers.push({ truename: tep[0], userid: tep[1] })
        })
      }
      json.leader = subData
      this.setGroupMemberLeaderList(this.subUsers)
      if (this.subUsers.length <= 0) {
        this.radioGroupDefault = '1'
        json.divide_type = '1'
      }
    },
    getDefaultDatas (data) {
      // const { groupMemberList } = this
      let tempv = []
      if (Array.isArray(data)) {
        data.map(value => {
          tempv.push((value.truename + '-' + value.userid))
        })
      }
      return tempv
    },
    // 小组信息input change事件
    handleGroupName (e) {
      const val = e.target.value
      this.editGroupValue = val.substring(0, 15)
    }
  }
}
</script>

<style lang="scss" scoped>
// .edit-btn {
//   margin-bottom: 14px;
//   margin-left: 16px;
//   height:32px;
//   line-height: 32px;
// }
// .leader-p {
//   margin-left: 16px;
// }
// .group-seting-footer {
//   position: absolute;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   border-top: 1px solid #e9e9e9;
//   padding: 10px 16px;
//   background-color: #fff;
//   text-align: left;
//   .save-btn {
//     margin-left: 161px;
//     margin-right: 16px;
//   }
// }
.checkbox-group-p {
  width: 500px;
  .parent-span {
    width: 150px;
    .child-permission {
      margin-left: 24px;
      span {
        display: inline-block;
      }
    }
  }
}
.margin-left-16 {
  margin-left: 16px;
}
.editlimit-btn {
  height: 32px;
  border-radius: 4px;
  border: solid 1px #ebebeb;
  background-color: #f5f5f5;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #333333;
  cursor: pointer;
  &:hover {
    background-color: #ffffff;
  }
}
i.iconicon-test34 {
  color: #b3b3b3;
  margin-right: 2px;
}
</style>
<style lang="scss">
  .in-tip-class {
    .ant-popover-content > .ant-popover-arrow {
      left: 6px !important;
    }
  }
</style>
